export function computeSwarmSignal(localContext, neighborSignals = []) {
  if (!neighborSignals.length) return null;

  const fentanylSignals = neighborSignals.filter(
    n => n.fentanyl > 5
  ).length;

  if (fentanylSignals >= 2) {
    return {
      swarmRisk: "ELEVATED",
      message: "regionalPattern",
      amplifyDecision: true,
    };
  }

  return {
    swarmRisk: "normal",
    amplifyDecision: false,
  };
}
